import React from 'react';
import classnames from 'classnames';
import {RichUtils} from 'draft-js';

import styles from './InlineToolbar.scss';

export function BoldButton(props) {
  const style = 'BOLD';

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    props.onClick(style);
  }
  const {editorState} = props;
  const active = editorState.getCurrentInlineStyle().has(style);

  return (
    <div
      className={classnames(styles.barButton, {[styles.active]: active}, styles.bold)}
      onMouseDown={handleClick}
    >
      B
    </div>
  )
}

export function ItalicButton(props) {
  const style = 'ITALIC';

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    props.onClick(style);
  }
  const {editorState} = props;
  const active = editorState.getCurrentInlineStyle().has(style);

  return (
    <div
      className={classnames(styles.barButton, {[styles.active]: active}, styles.italic)}
      onMouseDown={handleClick}
    >
      I
    </div>
  )
}

export function BulletsButton(props) {
  const style = 'unordered-list-item';

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    props.onClick(style);
  }
  const {editorState} = props;
  const active = RichUtils.getCurrentBlockType(editorState) === style;

  return (
    <div
      className={classnames(styles.barButton, {[styles.active]: active})}
      onMouseDown={handleClick}
    >
      L
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/controls/RichEditor/Tools.jsx